import { createStore } from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import jwtDecode from 'jwt-decode';

const dataState = createPersistedState({
  paths: [
    'accessToken',
    'refreshToken',
  ],
});

const store = createStore({
  plugins: [dataState],

  state() {
    return {
      accessToken: '',
      refreshToken: '',
      isAdmin: false,
      trainerId: null,
      daily: false,
      selectedTrainerId: null,
      canAddEvent: false,
      canApproveEvent: false,
      canDeleteEven: false,
      canEditEvent: false,
      closeEvent: false,
      expandedEvent: null,
    };
  },

  getters: {
    accessToken: (state) => state.accessToken,
    refreshToken: (state) => state.refreshToken,
    isAdmin: (state) => state.isAdmin,
    trainerId: (state) => state.trainerId,
    daily: (state) => state.daily,
    selectedTrainerId: (state) => state.selectedTrainerId,
    canAddEvent: (state) => state.canAddEvent,
    canApproveEvent: (state) => state.canApproveEvent,
    canDeleteEvent: (state) => state.canDeleteEvent,
    canEditEvent: (state) => state.canEditEvent,
    closeEvent: (state) => state.closeEvent,
    expandedEvent: (state) => state.expandedEvent,
  },

  mutations: {
    saveAccessToken(state, token) {
      state.accessToken = token;
      const decoded = jwtDecode(token);
      state.isAdmin = decoded.is_admin;
      state.canAddEvent = decoded.can_add_event;
      state.canApproveEvent = decoded.can_approve_event;
      state.canEditEvent = decoded.can_edit_event;
      state.canDeleteEvent = decoded.can_delete_event;
    },
    saveRefreshToken(state, token) {
      state.refreshToken = token;
    },

    SAVE_SELECTED_TRAINER_ID: (state, value) => {
      state.selectedTrainerId = value;
    },
    SAVE_DAILY: (state, value) => {
      state.daily = value;
    },
    SET_TRAINER_ID: (state) => {
      state.trainerId = jwtDecode(state.accessToken).trainer_id;
    },

    deleteAccessToken(state) {
      state.accessToken = '';
      state.isAdmin = false;
      state.trainerId = null;
      state.selectedTrainerId = null;
      state.daily = false;
      state.canEditEvent = false;
    },
    deleteRefreshToken(state) {
      state.refreshToken = '';
    },
    CHANGE_CLOSE_EVENT: async (state, value) => {
      state.closeEvent = value;
    },
    CHANGE_EXPANDED_EVENT: async (state, value) => {
      state.expandedEvent = value;
    },
    RESET_CHANGE_EVENT: async (state) => {
      state.expandedEvent = null;
      state.closeEvent = false;
    },
  },

  actions: {
    saveSelectedTrainerId: ({ commit }, value) => commit('SAVE_SELECTED_TRAINER_ID', value),
    saveDaily: ({ commit }, value) => commit('SAVE_DAILY', value),
    setTrainerId: ({ commit }) => commit('SET_TRAINER_ID'),
    changeCloseEvent: ({ commit }, value) => commit('CHANGE_CLOSE_EVENT', value),
    changeExpandedEvent: ({ commit }, value) => commit('CHANGE_EXPANDED_EVENT', value),
    resetChangeEvent: ({ commit }) => commit('RESET_CHANGE_EVENT'),
  },
});

export default store;
